import React, { useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import SubSkillCard from "../../shared/SubSkillCard/SubSkillCard";
import CompletionCard from "../../shared/CompletionCard/CompletionCard";
import Toaster from "../../shared/Toaster/Toaster";
import "./ProgressPage.scss";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { LinearProgress } from "@material-ui/core";
import {
  SkillsListInterface,
  ReachOverallInterface,
  ReachReportSkillList,
  ReachReportSubSkillList,
  LicenseObjectInterface,
  TestResultsDataInterface,
} from "../../../interfaces";
import withStyles from "@material-ui/core/styles/withStyles";
import Accordion from "@material-ui/core/Accordion/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import UnitProgress from "../../shared/UnitProgress/UnitProgress";
import TestResultCard from "../../shared/TestResultCard/TestResultCard";
import ReactGA from "react-ga";
import allActions from "../../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import ChartsComponent from "../../shared/ChartsComponent/ChartsComponent";
import { useParams } from "react-router-dom";
import { soloProducts, soloProductsMapper } from "../../../globalConstants";

const LinearProgressThick = withStyles(() => ({
  root: {
    height: 9,
    borderRadius: 10,
  },
}))(LinearProgress);

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.0)",
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
    },
  }
}));

function TabPanel(props: any) {
  const { children, value, index, prodId, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${prodId}-${index}`}
      // aria-labelledby={`scrollable-auto-tab-${prodId}-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  prodId: PropTypes.any.isRequired,
};

function a11yProps_dynamic(index: number, prodId: any) {
  return {
    id: `scrollable-auto-tab-${prodId}-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${prodId}-${index}`,
  };
}


const ProgressPage: React.FC = () => {
  // let chartData = `{\"Offset 0\":{\"Name\":\"Quarter 1\",\"StartDate\":\"1/1/2018\",\"EndDate\":\"3/31/2018\",\"UserActivitySummaryDetails\":{\"ActivitiesCompleted\":1,\"TutorialsCompleted\":0,\"MissionsCompleted\":0,\"AssignmentsCompleted\":0,\"ReviewTestsCompleted\":0,\"ProficiencyCoursesCompleted\":0,\"CPTCompleted\":0,\"TotalHoursinService\":\"03:20\",\"HoursinOne\":\"03:20\",\"HoursinReach\":\"00:00\",\"HoursinSelfPacedLearning\":\"03:20\",\"HoursInAssessment\":\"00:00\",\"HoursinTrainerLed\":\"00:00\",\"PlacementTests\":0,\"TOEICTestsCompleted\":0,\"TOEFLTestsCompleted\":0,\"ProductivityRequests\":0,\"TWTUsages\":0,\"BLAttendedSessionsCount\":0}},\"Offset 1\":{\"Name\":\"Quarter 2\",\"StartDate\":\"4/1/2018\",\"EndDate\":\"6/30/2018\",\"UserActivitySummaryDetails\":{\"ActivitiesCompleted\":0,\"TutorialsCompleted\":0,\"MissionsCompleted\":0,\"AssignmentsCompleted\":0,\"ReviewTestsCompleted\":0,\"ProficiencyCoursesCompleted\":0,\"CPTCompleted\":0,\"TotalHoursinService\":\"08:35\",\"HoursinOne\":\"08:35\",\"HoursinReach\":\"00:00\",\"HoursinSelfPacedLearning\":\"08:35\",\"HoursInAssessment\":\"00:00\",\"HoursinTrainerLed\":\"00:00\",\"PlacementTests\":0,\"TOEICTestsCompleted\":0,\"TOEFLTestsCompleted\":0,\"ProductivityRequests\":9,\"TWTUsages\":0,\"BLAttendedSessionsCount\":0}},\"Offset 2\":{\"Name\":\"Quarter 3\",\"StartDate\":\"7/1/2018\",\"EndDate\":\"9/30/2018\",\"UserActivitySummaryDetails\":{\"ActivitiesCompleted\":1,\"TutorialsCompleted\":1,\"MissionsCompleted\":76,\"AssignmentsCompleted\":0,\"ReviewTestsCompleted\":0,\"ProficiencyCoursesCompleted\":0,\"CPTCompleted\":0,\"TotalHoursinService\":\"17:21\",\"HoursinOne\":\"14:58\",\"HoursinReach\":\"02:24\",\"HoursinSelfPacedLearning\":\"17:21\",\"HoursInAssessment\":\"00:00\",\"HoursinTrainerLed\":\"00:00\",\"PlacementTests\":0,\"TOEICTestsCompleted\":0,\"TOEFLTestsCompleted\":0,\"ProductivityRequests\":0,\"TWTUsages\":0,\"BLAttendedSessionsCount\":0}},\"Offset 3\":{\"Name\":\"Quarter 4\",\"StartDate\":\"10/1/2018\",\"EndDate\":\"12/31/2018\",\"UserActivitySummaryDetails\":{\"ActivitiesCompleted\":0,\"TutorialsCompleted\":0,\"MissionsCompleted\":0,\"AssignmentsCompleted\":0,\"ReviewTestsCompleted\":0,\"ProficiencyCoursesCompleted\":0,\"CPTCompleted\":0,\"TotalHoursinService\":\"01:03\",\"HoursinOne\":\"01:03\",\"HoursinReach\":\"00:00\",\"HoursinSelfPacedLearning\":\"01:03\",\"HoursInAssessment\":\"00:00\",\"HoursinTrainerLed\":\"00:00\",\"PlacementTests\":0,\"TOEICTestsCompleted\":0,\"TOEFLTestsCompleted\":0,\"ProductivityRequests\":1,\"TWTUsages\":0,\"BLAttendedSessionsCount\":0}},\"DateRange\":{\"StartDate\":\"1/1/2018\",\"EndDate\":\"12/31/2018\"}}`;
  let [loaderFlag, setLoaderFlag] = useState(false);
  const { paramProdID } = useParams();
  const allInfo = useSelector((state: any) => state);
  const [pageInited, setPageInited] = useState(false);
  const dispatch = useDispatch();
  const [portalLoginURL, setPortalLoginURL] = useState("");
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [l1Expanded, setL1Expanded] = React.useState<string | false>(false);
  const [l2Expanded, setL2Expanded] = React.useState<string | false>(false);
  const [productTabIndex, setproductTabIndex] = useState(0);
  const [skillTabIndex, setskillTabIndex] = useState(0);
  const [sprintLevelTab, setSprintLevelTab] = useState(0);
  const [soloTab, setSoloTab] = useState(0);
  const [isSoloStructuredData, setSoloStructuredData] = useState(true);
  const [skillsProgressList, setskillsProgressList] = useState<Array<SkillsListInterface> | undefined>(undefined);
  const [allCompletedList, setallCompletedList] = useState([]);
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [allUnitsIndivList, setAllUnitsIndivList] = useState([]);
  const [allUnitsIndivListSolo, setAllUnitsIndivListSolo] = useState([]);
  const [structuredLevelProgress, setStructuredLevelProgress] = useState([]);
  const [structuredSoloData, setStructuredSoloData] = useState([]);
  const [testResultsList, setTestResultsList] = useState<Array<TestResultsDataInterface> | undefined>([]);
  const [reachReportsCompletedList, setreachReportsCompletedList] = useState<ReachOverallInterface | undefined>(
    undefined
  );
  const [reachReportsSkillList, setreachReportsSkillList] = useState<Array<ReachReportSkillList> | undefined>(
    undefined
  );
  const [reachReportSubSkillsList, setreachReportSubSkillsList] = useState<Array<ReachReportSubSkillList> | undefined>(
    undefined
  );
  const [productsList, setproductsList] = useState<Array<LicenseObjectInterface> | undefined>(undefined);
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };

  const handleProductChange = (event: any, newValue: any) => {
    setproductTabIndex(newValue);
    const pushURL: string = `${window.location.protocol}//${window.location.host}/progress`;
    let productID: string = "";
    if(productsList && !!!productsList[newValue].productId.includes('$')){
      productID = productsList[newValue].productId;
      if(productID){
        window.history.pushState(null, "", `${pushURL}/${productID}`)
        productID = '';
      }  else {
        window.history.pushState(null, "", `${pushURL}`)
      }
    } else {
      window.history.pushState(null, "", `${pushURL}`)
    }    
  };

  const handleSkillChange = (event: any, newValue: any) => {
    setskillTabIndex(newValue);
  };

  const handleSprintLevelChange = (event: any, newValue: any) => {
    setSprintLevelTab(newValue);
  };
  const handlesSoloChange = (event: any, newValue: any) => {
    setSoloTab(newValue);
  };
  let filledPartList: any = [];

  const calculateAllTotalPerSkill = (allSkillsList: any) => {
    let allSkillsTotal = [];
    for (let i = 0; i < allSkillsList.length; i++) {
      let perSkillTotalPrint = {
        id: i,
        name: allSkillsList[i]["skilltitle"],
        prework: 0,
        totalprework: 0,
        homework: 0,
        totalhomework: 0,
        sessions: 0,
        totalsessions: 0,
        level: allSkillsList[i]["skilllevel"],
      };
      for (let j = 0; j < allSkillsList[i].skillcourses.length; j++) {
        perSkillTotalPrint["prework"] += parseInt(allSkillsList[i].skillcourses[j]["preworkcompleted"]);
        perSkillTotalPrint["totalprework"] += parseInt(allSkillsList[i].skillcourses[j]["totalprework"]);
        perSkillTotalPrint["homework"] += parseInt(allSkillsList[i].skillcourses[j]["homeworkcompleted"]);
        perSkillTotalPrint["totalhomework"] += parseInt(allSkillsList[i].skillcourses[j]["totalhomework"]);
        perSkillTotalPrint["sessions"] += parseInt(allSkillsList[i].skillcourses[j]["sessioncompleted"]);
        perSkillTotalPrint["totalsessions"] += parseInt(allSkillsList[i].skillcourses[j]["totalsession"]);
      }
      allSkillsTotal.push(perSkillTotalPrint);
    }
    return allSkillsTotal;
  };

  const renderReachSubSkill = (reachReportSubSkillsList: Array<object>, skillID: string) => {
    let subskillFilteredList: any = [];
    if (reachReportSubSkillsList && reachReportSubSkillsList.length > 0) {
      reachReportSubSkillsList.map((subskill: any) => {
        if (subskill.SkillId === skillID) {
          subskillFilteredList.push(
            <div className="mission-container">
              <div className="mission-title">{subskill.BadgeName}</div>
              <div className="mission-bar">
                <LinearProgressThick
                  variant="determinate"
                  value={
                    parseInt(subskill["TotalMission"]) !== 0
                      ? (parseInt(subskill["MissionPassed"]) / parseInt(subskill["TotalMission"])) * 100
                      : 0
                  }
                />
              </div>
              <div className="mission-metric">
                {subskill["MissionPassed"]}/{subskill["TotalMission"]}
              </div>
            </div>
          );
        }
      });
    }
    return subskillFilteredList;
  };

  const afterGetSkillsProgress = () => {
    if (!!!allInfo.skillsProgress.isLoading) {
      if (!!!allInfo.skillsProgress.isFailed) {
        if (!!allInfo.skillsProgress.data) {
          // handle error page here - false
          setskillsProgressList(allInfo.skillsProgress.data.getSkillsReport || []);
          let allCompletedListbefore: any = calculateAllTotalPerSkill(
            allInfo.skillsProgress.data.getSkillsReport || []
          );
          setallCompletedList(allCompletedListbefore);
        } else {
          // handle error page here - true
        }
      } else {
        // handle error page here - true
      }
    }
  };

  const getSkillsProgress = async () => {
    // License check for sprint business skills
    if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
      let licensesList: any =
        allInfo.peopleInformation &&
          allInfo.peopleInformation.data &&
          allInfo.peopleInformation.data.getpeopleInformation
          ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
          : [];
      const licenseIDList = getOnlyIds(licensesList) || [];
      if (licenseIDList.indexOf("18") >= 0) {
        if (!!!allInfo.skillsProgress.data && !!!allInfo.skillsProgress.isLoading) {
          await dispatch(allActions.skillsProgressAction.getSkillsProgress(allInfo.common.leuId));
        }
      }
      getReachProgress();
    }
  };

  const afterGetReachProgress = () => {
    if (!!!allInfo.reachProgress.isLoading) {
      if (!!!allInfo.reachProgress.isFailed && !!allInfo.reachProgress.data) {
        const reachReportsData = JSON.parse(allInfo.reachProgress.data.getReachReport);
        setreachReportsCompletedList(reachReportsData.data[0]);
        setreachReportsSkillList(reachReportsData.data[1]);
        setreachReportSubSkillsList(reachReportsData.data[2]);
        // handle error page here - false
      } else {
        // handle error page here - true
      }
    }
  };

  const getReachProgress = async () => {
    // License check for Reach API
    let licensesList: any =
      allInfo.peopleInformation && allInfo.peopleInformation.data && allInfo.peopleInformation.data.getpeopleInformation
        ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
        : [];
    const licenseIDList = getOnlyIds(licensesList) || [];
    if (licenseIDList.indexOf("15") >= 0) {
      const { accountId, token }: any = allInfo.peopleInformation.data.getpeopleInformation;
      if (!!!allInfo.reachProgress.data && !!!allInfo.reachProgress.isLoading) {
        await dispatch(allActions.reachProgressAction.getReachProgress(allInfo.common.leuId, accountId, token));
      }
    }
    getSprintLevelProgressAPI();
   
  };

  const sugarCoatNamesAndFilter = (rawLics: Array<LicenseObjectInterface>) => {
    let finalRawLicenses: any = [],
      rawLicenseArr: Array<LicenseObjectInterface> = rawLics;
    const mandatoryTabs: any = [
      {
        productId: "$0",
        productName: "Activity report",
        active: 1
      },
      {
        productId: "$1",
        productName: "Test results",
        active: 1,
      }
    ]
    const sugarCoatedPrefixes: Array<any> = [
      {
        productId: "15",
        productName: "Reach",
      },
      {
        productId: "18",
        productName: "Sprint Business Skills",
      },
      {
        productId: "20",
        productName: "Sprint Business English",
      },
      {
        productId: "21",
        productName: "Solo Business English",
      },
      {
        productId: "22",
        productName: "Solo Business German",
      },
      {
        productId: "23",
        productName:"Solo Business French",
      },
      {
        productId: "24",
        productName: "Solo Business Spanish",
      },
      {
        productId: "$0",
        productName: "Activity report",
      },
      {
        productId: "$1",
        productName: "Test results",
      }
    ];

    rawLicenseArr = [...mandatoryTabs, ...rawLicenseArr];
    // Remove licenses based on active state
    for (let k = 0; k < rawLicenseArr.length; k++) {
      if (parseInt(rawLicenseArr[k]["active"]) === 0) {
        rawLicenseArr.splice(k, 1);
      }
    }

    for (let i = 0; i < rawLicenseArr.length; i++) {
      for (let j = 0; j < sugarCoatedPrefixes.length; j++) {
        if (rawLicenseArr[i]["productId"] === sugarCoatedPrefixes[j]["productId"]) {
          finalRawLicenses.push(rawLicenseArr[i]);
        }
      }
    }

    // sugarcoat names in licenses
    for (let i = 0; i < finalRawLicenses.length; i++) {
      for (let j = 0; j < sugarCoatedPrefixes.length; j++) {
        if (parseInt(finalRawLicenses[i]["active"]) === 1) {
          if (finalRawLicenses[i]["productId"] === sugarCoatedPrefixes[j]["productId"]) {
            finalRawLicenses[i]["productName"] = sugarCoatedPrefixes[j]["productName"];
          }
        } else {
          finalRawLicenses.splice(i, 1);
        }
      }
    }
    return finalRawLicenses;
  };

  const getOnlyIds = (licenseArr: any) => {
    let lArr: any = [];
    if (licenseArr && licenseArr.length > 0) {
      licenseArr.map((prod: any) => {
        lArr.push(prod.productId);
      });
    }
    return lArr;
  };

  const afterGetTestResultsAPI = () => {
    if (!!!allInfo.testProgress.isLoading) {
      if (!!!allInfo.testProgress.isFailed) {
        if (!!allInfo.testProgress.data) {
          setTestResultsList(JSON.parse(allInfo.testProgress.data.getAllTestProgress));
          // handle error page here - false
        }
      } else {
        // handle error page here - true
      }
      getSkillsProgress();
    }
  };

  const getTestResultsAPI = async () => {
    if (!!!allInfo.testProgress.data && !!!allInfo.testProgress.isLoading) {
      await dispatch(
        allActions.testProgressAction.getTestProgress(
          allInfo.common.leuId,
          allInfo.peopleInformation.data.getpeopleInformation.accountId
        )
      );
    }
  };

  const initGoogleAnalytics = () => {
    if (allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85) === "1") {
      const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
      ReactGA.initialize(trackingId);
      const url = window.location.pathname;
      ReactGA.set({ page: url });
      ReactGA.pageview(url);
    }
  };

  const afterGetPeopleInfo = () => {
    if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
      let licensesList: any =
        allInfo.peopleInformation &&
          allInfo.peopleInformation.data &&
          allInfo.peopleInformation.data.getpeopleInformation
          ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
          : [];
      // handle error page here - false
      initGoogleAnalytics();
      setproductsList(sugarCoatNamesAndFilter(licensesList));
      generatePortalURL();
    } else {
      // handle error page here - true
    }
  };

  const getPeopleInfo = () => {
    afterGetPeopleInfo();
  };

  const handleAccordionChange = (panel: string, level?: number) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean
  ) => {
    if (level === 1) {
      setL1Expanded(isExpanded ? panel : false);
    } else if (level === 2) {
      setL2Expanded(isExpanded ? panel : false);
    } else {
      setExpanded(isExpanded ? panel : false);
    }
  };

  const filterSpecificProductCourses = (data: any, ID: number, isSolo=false) => {
    return {
      skilllevel: data.skilllevel,
      skilltitle: data.skilltitle,
      userid: data.userid,
      username: data.username,
      skillcourses: !!!isSolo? data.skillcourses.filter((course: any) => course.skilltypeid === ID) : data.skillcourses,
    };
  };

  const restructureSprintLevelProgressData = (data: any, isSolo=false) => {
    let structuredArr: any = [],
      levelsList: any = [];
   
    if (data && data.data && data.data.userskillscourseslist && data.data.userskillscourseslist.length > 0) {
      data.data.userskillscourseslist.map((datum: any) => {
        if (levelsList.indexOf(datum.skilllevel) === -1) {
          let singleDataObj: any = {
            level: datum.skilllevel,
            courses: [],
          };
          singleDataObj.courses.push(filterSpecificProductCourses(datum, 2, isSolo));
          structuredArr.push(singleDataObj);
          levelsList.push(datum.skilllevel);
        } else {
          for (let i = 0; i < structuredArr.length; i++) {
            if (structuredArr[i].level === datum.skilllevel) {
              structuredArr[i].courses.push(filterSpecificProductCourses(datum, 2, isSolo));
            }
          }
        }
      });
    }

    if(structuredArr && structuredArr.length > 0) {      
      let sortedCourses: any = structuredArr[0].courses.sort((a: any, b: any) => a.skillcourses[0].courseparttitle.toLowerCase().localeCompare(b.skillcourses[0].courseparttitle.toLowerCase()))
      structuredArr[0]["courses"] = sortedCourses;
      for(let i=0; i < structuredArr.length; i++) {
        structuredArr[i].parts = {
          parts:generatePartsPrint(structuredArr[i], isSolo)
        }
      }
      return structuredArr;  
    } else return []
  };

  const seperateIndivUnitCountBasedOnLevel = (allCompletedListUnitbefore: any) => {    
    let structuredArr: any = [];
    let levelsList: any = [];
    if (allCompletedListUnitbefore && allCompletedListUnitbefore.length > 0) {
      allCompletedListUnitbefore.map((datum: any) => {
        if (levelsList.indexOf(datum.level) === -1) {
          let singleDataObj: any = {
            level: datum.level,
            prework: 0,
            totalprework: 0,
            sessions: 0,
            totalsessions: 0,
            units: [],
          };
          singleDataObj.units.push(datum);
          structuredArr.push(singleDataObj);
          levelsList.push(datum.level);
        } else {
          for (let i = 0; i < structuredArr.length; i++) {
            if (structuredArr[i].level === datum.level) {
              structuredArr[i].units.push(datum || {});
            }
          }
        }
      });
    }
    return structuredArr;
  };

  const calculateOverallUnitsCompletion = (seperatedUnitsList: Array<any>) => {
    for (let i = 0; i < seperatedUnitsList.length; i++) {
      for (let j = 0; j < seperatedUnitsList[i].units.length; j++) {
        seperatedUnitsList[i].prework += seperatedUnitsList[i].units[j].prework;
        seperatedUnitsList[i].totalprework += seperatedUnitsList[i].units[j].totalprework;
        seperatedUnitsList[i].sessions += seperatedUnitsList[i].units[j].sessions;
        seperatedUnitsList[i].totalsessions += seperatedUnitsList[i].units[j].totalsessions;
      }
    }
    return seperatedUnitsList;
  };

  const generatePortalURL = () => {
    if (!!!allInfo.portalLogin.isFailed && !!allInfo.portalLogin.data) {
      let { key, signature } = JSON.parse(allInfo.portalLogin.data.getPortalLoginKey);
      let url = process.env["REACT_APP_PROFILE_URL"] + "/account/portallogin?key=" + key + "&signature=" + signature + "&virtual_step=1";
      // handle error page here - false
      setPortalLoginURL(url);
      getTestResultsAPI();
    } else {
      // handle error page here - true
    }
  };

  const afterSprintLevelProgressAPI = () => {
    if (!!!allInfo.sprintLevelProgress.isLoading) {
      if (!!!allInfo.sprintLevelProgress.isFailed && !!allInfo.sprintLevelProgress.data) {
        let reStructuredWithTotal: any;
        reStructuredWithTotal = restructureSprintLevelProgressData(allInfo.sprintLevelProgress);
        if (
          allInfo.sprintLevelProgress &&
          allInfo.sprintLevelProgress.data &&
          allInfo.sprintLevelProgress.data.userskillscourseslist &&
          allInfo.sprintLevelProgress.data.userskillscourseslist.length > 0
        ) {
          for(let i=0;i<reStructuredWithTotal.length;i++){
            reStructuredWithTotal[i].parts.parts.map((singleFilledPart: any) => {
              let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(
                singleFilledPart.courses
              );
              singleFilledPart.total = calculateOverallUnitsCompletion(seperateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || []);
            })
          }
          let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(
            allInfo.sprintLevelProgress.data.userskillscourseslist
          );
          setAllUnitsIndivList(mergeUnits(calculateOverallUnitsCompletion(seperateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || [])));
          setStructuredLevelProgress(reStructuredWithTotal);
        } else {
          setAllUnitsIndivList([]);
        }
      } else {
        // handle error page here - true
      }
    }
  };
  const afterSoloProgressAPI = () => {
    let userskillscourseslist : any = {};
    userskillscourseslist.data ={};
    userskillscourseslist.data.userskillscourseslist=[];
    if (!!!allInfo.soloProgressDetails.isLoading) {
      if (!!!allInfo.soloProgressDetails.isFailed && !!allInfo.soloProgressDetails.data && !! allInfo.soloProgressDetails.data.soloProgressDetails) {
        let reStructuredWithTotal: any;
        let remappedJSON : any= {};
        remappedJSON["skilltitle"]={};
        allInfo.soloProgressDetails.data.soloProgressDetails.map((soloDetails : any, index : number)=> {
          userskillscourseslist = remapJSON(remappedJSON, soloDetails, allInfo, userskillscourseslist);
        });
        reStructuredWithTotal = restructureSprintLevelProgressData(userskillscourseslist, true);
        if (
          allInfo.soloProgressDetails &&
          allInfo.soloProgressDetails.data &&
          allInfo.soloProgressDetails.data.soloProgressDetails &&
          allInfo.soloProgressDetails.data.soloProgressDetails.length > 0
        ) {
          for(let i=0;i<reStructuredWithTotal.length;i++){
            reStructuredWithTotal[i].parts.parts.map((singleFilledPart: any) => {
              let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(
                singleFilledPart.courses
              );
              singleFilledPart.total = calculateOverallUnitsCompletion(seperateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || []);
            })
          }

          let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(
            userskillscourseslist.data.userskillscourseslist
          );
          setAllUnitsIndivListSolo(mergeUnits(calculateOverallUnitsCompletion(seperateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || [])));
          setSoloStructuredData(false);
          setStructuredSoloData(reStructuredWithTotal);
        } else {
          setSoloStructuredData(false);
          setAllUnitsIndivListSolo([]);
        }
      } else {
        // handle error page here - true
      }
      if(allInfo.soloProgressDetails.data.soloProgressDetails === null) setLoaderFlag(false); 
    }
  };


  const getSprintLevelProgressAPI = async () => {
    // License check for sprint level progress
    let licensesList: any =
      allInfo.peopleInformation && allInfo.peopleInformation.data && allInfo.peopleInformation.data.getpeopleInformation
        ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
        : [];
    const licenseIDList = getOnlyIds(licensesList) || [];
    if (licenseIDList.indexOf("20") >= 0) {
      if (!!!allInfo.sprintLevelProgress.data && !!!allInfo.sprintLevelProgress.isLoading) {
        await dispatch(allActions.sprintLevelProgressAction.getSprintLevelProgress(parseInt(allInfo.common.leuId)));
      }
    }
  };


  const getSoloProgressAPI = async () => {
    let licensesList: any =
      allInfo.peopleInformation && allInfo.peopleInformation.data && allInfo.peopleInformation.data.getpeopleInformation
        ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
        : [];
    const licenseIDList = getOnlyIds(licensesList) || [];
    const soloProductId = soloProductsMapper.filter((solo: any, index: number)=> licenseIDList.includes(soloProducts[index]));

    if (!!soloProductId && !!allInfo.peopleInformation.data) {
      await dispatch(allActions.soloProgressDetailsAction.getSoloProgress(allInfo.peopleInformation.data.getpeopleInformation.edgeUid, Number(soloProductId[0])));
    }
  };

  const shiftInitialTab = () => {
    if (parseInt(paramProdID) ? paramProdID : "") {
      switchTab();
    } else {
      setIsInvalidURL(true);
    }
  }

  const switchTab = () => {
    let productIndex = 0, prodIDFound = false;
    if (productsList && productsList.length > 0) {
      productsList.map((prod: any) => {
        if (prod.active) {
          if (parseInt(paramProdID) === parseInt(prod.productId)) {
            setproductTabIndex(productIndex);
            prodIDFound = true;
          }
          productIndex += 1;
        }
      })
      if (!prodIDFound) {
        setIsInvalidURL(true);
      }
    }
  }

  const generatePartsPrint = (structuredUnParted: any, isSolo=false) => {
    let partsList = []; let partsStringList = [];
      for (let j = 0; j < structuredUnParted.courses.length; j++) {
        for (let k = 0; k < structuredUnParted.courses[j].skillcourses.length; k++) {

          if (partsStringList.indexOf(structuredUnParted.courses[j].skillcourses[0].courseparttitle) === -1) {
            partsStringList.push(structuredUnParted.courses[j].skillcourses[0].courseparttitle);
            let partsObj = {
              "level": structuredUnParted.courses[j].skilllevel,
              "courseparttitle": structuredUnParted.courses[j].skillcourses[0].courseparttitle,
              "courses": [],
              "total": [],
            }
            partsList.push(partsObj)
          }
        }
      }
    return fillPartsArray(partsList, structuredUnParted)
  }

  const hashText = (str: string) => {
    var hash = 0, i, chr, len;
    str = str.replace(" ","");
    if (str.length === 0) return hash;
    for (i = 0, len = str.length; i < len; i++) {
      chr   = str.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
  };
  
  const fillPartsArray = (partsList: any, structuredUnParted: any) => {
    let notedDownTitles: any = [];
      for (let j = 0; j < structuredUnParted.courses.length; j++) {
        for (let k = 0; k < structuredUnParted.courses[j].skillcourses.length; k++) {
          partsList.map((part: any) => {
            if (part.courseparttitle === structuredUnParted.courses[j].skillcourses[0].courseparttitle) {
              if (notedDownTitles.indexOf(structuredUnParted.courses[j].skilltitle) === -1) {
                notedDownTitles.push(structuredUnParted.courses[j].skilltitle);
                part.courses.push(structuredUnParted.courses[j])
              }
            }
          })
        }
      }
    return filledPartList = partsList;
  }

  const mergeUnits = (unmergedList: any) => {
    let allUnitsList: any = [];
    for(let i=0; i< unmergedList.length; i++){
      allUnitsList.push(...unmergedList[i].units)
    }    
    return allUnitsList;
  }

  const getIndivUnitScoreObj = (skillTitle: string, indvidualList : any) => {
    if(indvidualList && indvidualList.length > 0){
      return indvidualList.filter((unit: any)=>{
        return unit.name === skillTitle;
      })[0] || []
    }
  }

  const getPartTitle = (partTitle?:string) => {
    if(partTitle){      
      return <div className="h5_title">{translate('progress_partText')} {partTitle}</div>
    }   else {
      return <div className="h5_title">--</div>
    }
  }

  useEffect(() => {
    if (productsList && productsList.length > 0) {
      shiftInitialTab();
    }
  }, [productsList])

  useEffect(() => {
    setPageInited(true);
    sessionStorage.removeItem('chInited');
  }, [])

  useEffect(() => {
    if(!!window.location.href.split("/")[4] && allInfo.common.productID!==window.location.href.split("/")[4])
    {
      dispatch(allActions.commonActions.setProductID((window.location.href.split("/")[4])));  
    }
  }, [window.location.href, allInfo.common.productID])

  useEffect(() => {
    if (!!!allInfo.common.isLoading && !!!allInfo.peopleInformation.isLoading && !!!allInfo.portalLogin.isLoading) {
      if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
        getPeopleInfo();
      }
    }
  }, [allInfo.common, allInfo.peopleInformation, allInfo.portalLogin]);

  useEffect(() => {
    if (!!!allInfo.skillsProgress.isLoading) {
      afterGetSkillsProgress();
    }
  }, [allInfo.skillsProgress]);

  useEffect(() => {
    if (!!!allInfo.testProgress.isLoading) {
      afterGetTestResultsAPI();
    }
  }, [allInfo.testProgress]);

  useEffect(() => {
    if (!!!allInfo.reachProgress.isLoading) {
      afterGetReachProgress();
    }
  }, [allInfo.reachProgress]);

  useEffect(() => {
    if (!!!allInfo.sprintLevelProgress.isLoading) {
      if (!!allInfo.sprintLevelProgress.data) {
        afterSprintLevelProgressAPI();
      }
    }
  }, [allInfo.sprintLevelProgress]);

  useEffect(() => {
    if (!!!allInfo.soloProgressDetails.isLoading &&!!!allInfo.soloProgressDetails.isFailed && soloProducts.filter((solo: any)=> allInfo.common.productID === solo).length > 0) {
      if (!!allInfo.soloProgressDetails.data) {
        afterSoloProgressAPI();
      } else {
        getSoloProgressAPI(); 
      }
    }
  }, [allInfo.soloProgressDetails, allInfo.peopleInformation, allInfo.common.productID]);

  useEffect(() => {
    if (
      !!!allInfo.peopleInformation.isLoading &&
      !!!allInfo.portalLogin.isLoading &&
      !!!allInfo.skillsProgress.isLoading &&
      !!!allInfo.testProgress.isLoading &&
      !!!allInfo.reachProgress.isLoading &&
      (!!!allInfo.sprintLevelProgress.isLoading) &&
      ((!soloProducts.includes(allInfo.common.productID)) || (soloProducts.includes(allInfo.common.productID) && !isSoloStructuredData))
    ) {
      setLoaderFlag(false);
      if (isInvalidURL) {
        setTimeout(() => {
          window.history.pushState(null, "", `${window.location.protocol}//${window.location.host}/progress`)
        }, 1000)
      }
    } else {
      setLoaderFlag(true);
    }
  }, [
    allInfo.peopleInformation,
    allInfo.portalLogin,
    allInfo.skillsProgress,
    allInfo.testProgress,
    allInfo.reachProgress,
    allInfo.sprintLevelProgress,
    isSoloStructuredData
  ]);

  useEffect(()=> {
    if(!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data)
    {
      const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
      if(!!!allInfo.skillOutcomeSummary.isLoading && !!!allInfo.skillOutcomeSummary.isFailed && !!! allInfo.skillOutcomeSummary.data)
      {
         dispatch(allActions.skillOutcomeSummaryAction.getSkillOutcome(userId));
      }
    }

  }, [allInfo.peopleInformation]);

  useEffect(() => {
    if(!!!allInfo.peopleInformation.isLoading && !!allInfo.peopleInformation.data) {
      let licences = allInfo.peopleInformation.data.getpeopleInformation.license;
      if(licences.length > 0) {
        dispatch(allActions.commonActions.setProductID(licences[0].productId));
      }
    }

    if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.tmsCourses.isLoading) {
      if(!!allInfo.peopleInformation.data && !!allInfo.tmsCourses.data){
        const filteredSprintLevelLic = allInfo.peopleInformation.data.getpeopleInformation.license.filter((prod: any)=>{
          return prod.productId === "20" ||  prod.productId === "18" ||  prod.productId === "21"||  prod.productId === "22"||  prod.productId === "23"||  prod.productId === "24";
        })
        if (!!!allInfo.currentCourseDetails.isLoading && !!!allInfo.currentCourseDetails.isFailed &&!!!allInfo.currentCourseDetails.data){
              const uuId = allInfo.common.luuId;
              let activeCourse = allInfo.tmsCourses.data.getTMSGetCourse.filter((courseFilter: any) =>
              courseFilter.status==="3" || courseFilter.status==="1"
          );
          let courseId = 0;
          if(activeCourse.length >0)
          {
            courseId = activeCourse[0].courseId;
          }
          else {
            let latestCompleted = allInfo.tmsCourses.data.getTMSGetCourse.filter((courseFilter: any) =>
            courseFilter.status==="5"
            );
            courseId = latestCompleted.length>0? latestCompleted.sort((a: any, b: any) => b.courseId -a.courseId)[0].courseId : 0;
          }
          if(filteredSprintLevelLic && filteredSprintLevelLic.length > 0){
               dispatch(allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(allInfo.common.leuId,filteredSprintLevelLic[0].licenseId,filteredSprintLevelLic[0].productId, uuId, courseId));
          }
        }
      }
      if(!!allInfo.currentCourseDetails.isFailed)
      {
        setLoaderFlag(false);
        dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
      }
    }
  }, [allInfo.peopleInformation, allInfo.currentCourseDetails, allInfo.tmsCourses]);
  

  useEffect(() => {
    if (!!!allInfo.tmsCourses.isLoading && !!!allInfo.tmsCourses.isFailed &&!!!allInfo.tmsCourses.data) {
      const uuId = allInfo.common.luuId;
       dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
    }
    
  }, []);



  return (
    <React.Fragment>
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />
      <Loader showLoader={loaderFlag} />
      {true ? (
        <div className="progresspage-container">
          <div className="progresspage-title">
            <h1>{translate("progress_title")}</h1>
          </div>
          <div className="progresspage-body">
            <div className={classes.root}>
              <AppBar position="static" color="default">
                <Tabs
                  value={productTabIndex}
                  className={"tabs-trigger-container h1-tab"}
                  onChange={handleProductChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="Product list tabs"
                >
                  {productsList &&
                    productsList.map((product: any, mainIndex: number) => {
                      return (
                        <Tab key={product.productId} label={product.productName} {...a11yProps_dynamic(mainIndex, "auto")} />
                      );
                    })}
                </Tabs>
              </AppBar>
              {productsList &&
                productsList.map((product: any, listIndex: number) => {
                  if (product.productId === "18") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        {skillsProgressList && skillsProgressList.length > 0 ? (
                          <div className="inside-tab">
                            <AppBar position="static" color="default">
                              <Tabs
                                value={skillTabIndex}
                                className={"tabs-trigger-container h2-tab"}
                                onChange={handleSkillChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="Skill list tabs"
                              >
                                {skillsProgressList &&
                                  skillsProgressList.map((skill: any, index: number) => {
                                    return (
                                      <Tab
                                        key={index * Math.random()}
                                        label={skill["skilltitle"]}
                                        {...a11yProps_dynamic(index, "18")}
                                      />
                                    );
                                  })}
                              </Tabs>
                            </AppBar>
                            {skillsProgressList &&
                              skillsProgressList.map((skill: any, index: number) => {
                                return (
                                  <TabPanel value={skillTabIndex} index={index} key={index * Math.random()} prodId={"18"}>
                                    <div className="skill-note">{translate("progress_skill_note")}</div>
                                    <div className="completion-card-cover">
                                      <CompletionCard
                                        type="0"
                                        title={translate("progress_overall_card_title_prework")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                      <CompletionCard
                                        type="1"
                                        title={translate("progress_overall_card_title_homework")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                      <CompletionCard
                                        type="2"
                                        title={translate("progress_overall_card_title_session")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                      <CompletionCard
                                        type="8"
                                        title={translate("progress_overall_card_title_badge")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                      <CompletionCard
                                        type="3"
                                        title={translate("progress_overall_card_title_certificate")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                    </div>
                                    <div className="subskill-list">
                                      {skillsProgressList[index].skillcourses &&
                                      skillsProgressList[index].skillcourses.length > 0 ? (
                                        skillsProgressList[index].skillcourses.map((subskillData: any) => {
                                          return (
                                            <SubSkillCard
                                              subSkillData={subskillData}
                                              showHomeWork={true}
                                              skillSummary = {allInfo.skillOutcomeSummary.data}
                                            ></SubSkillCard>
                                          );
                                        })
                                      ) : (
                                        <div className="emptySubSkill">{translate("progress_noSubskill")}</div>
                                      )}
                                    </div>
                                  </TabPanel>
                                );
                              })}
                          </div>
                        ) : (
                            <div className="no-data-tab">{translate("progress_tab_nodata")}</div>
                          )}
                      </TabPanel>
                    );
                  } else if (product.productId === "15") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        {reachReportsCompletedList && reachReportsSkillList && reachReportSubSkillsList ? (
                          <div className="tab-main-body m0 p0">
                            <div className="completion-card-cover">
                              <CompletionCard
                                type="4"
                                title={translate("progress_overall_card_title_skillsCompleted")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="5"
                                title={translate("progress_overall_card_title_badgesEarned")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="6"
                                title={translate("progress_overall_card_title_missionsPassed")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="7"
                                title={translate("progress_overall_card_title_timeInReach")}
                                cardData={reachReportsCompletedList || {}}
                              />
                            </div>
                            <div className="reach-skills-body-container">
                              <ul className="reach-skills-card-ul">
                                {reachReportsSkillList &&
                                  reachReportsSkillList.map((skill: any) => {
                                    return (
                                      <Accordion
                                        className={
                                          skill["UserCurrentGoal"] === 0
                                            ? "reach-skill-card"
                                            : "reach-skill-card user-selected"
                                        }
                                        expanded={expanded === `${skill["SkillId"]}`}
                                        onChange={handleAccordionChange(`${skill["SkillId"]}`)}
                                      >
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1a-content"
                                          id="panel1a-header"
                                        >
                                          <div className="reach-skill-title">
                                            {" "}
                                            {skill["SkillName"]}{" "}
                                            {parseInt(skill["UserCurrentGoal"]) === 1 &&
                                              parseInt(skill["IsAchieved"]) === 0 ? (
                                                <div className="inprogress-chip">{translate("progress_inprogress")}</div>
                                              ) : (
                                                ""
                                              )}
                                          </div>
                                        </AccordionSummary>
                                        <AccordionDetails className="accordion-details">
                                          <li className="reach-skills-card-li">
                                            <div className="reach-skill-subskill-list">
                                              <div className="missions-list-cover">
                                                {reachReportSubSkillsList && (
                                                  <div>
                                                    {renderReachSubSkill(reachReportSubSkillsList, skill["SkillId"])}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </li>
                                        </AccordionDetails>
                                      </Accordion>
                                    );
                                  })}
                              </ul>
                            </div>
                          </div>
                        ) : (
                            <div className="no-data-tab">{translate("progress_tab_nodata")}</div>
                          )}
                      </TabPanel>
                    );
                  } else if (product.productId === "20") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        {structuredLevelProgress && structuredLevelProgress.length > 0 ? (
                          <div className="tab-main-body m0 p0 inside-tab">
                            <div className="reach-skills-body-container">
                              <div className="levels-progress-skills-card-ul">
                                <div>
                                  <AppBar position="static" color="default">
                                    <Tabs
                                      value={sprintLevelTab}
                                      onChange={handleSprintLevelChange}
                                      className={"tabs-trigger-container h2-tab"}
                                      indicatorColor="primary"
                                      textColor="primary"
                                      variant="scrollable"
                                      scrollButtons="auto"
                                      aria-label="sprint levels level tabs"
                                    >
                                      {structuredLevelProgress &&
                                        structuredLevelProgress.map((skill: any, index: number) => {
                                          return (
                                            <Tab
                                              label={skill["level"]}
                                              key={index * Math.random()}
                                              {...a11yProps_dynamic(index, "20")}
                                            />
                                          );
                                        })}
                                    </Tabs>
                                  </AppBar>
                                  {structuredLevelProgress &&
                                    structuredLevelProgress.map((skill: any, index: number) => {
                                      return (
                                        <TabPanel value={sprintLevelTab} index={index} key={index * Math.random()} prodId={"20"}>
                                          {
                                            skill.parts.parts && skill.parts.parts.length > 0 && skill.parts.parts.map((indivPart: any)=>{
                                              return (
                                                <div className="parts-block">
                                                  {indivPart && (
                                                    <div className="completion-card-cover spread">
                                                      <div className="part-title">{getPartTitle(indivPart.courseparttitle)}</div>
                                                      <CompletionCard
                                                        type="0"
                                                        title={translate("progress_overall_card_title_prework")}
                                                        cardData={indivPart.total[0]|| {}}
                                                      />
                                                      <CompletionCard
                                                        type="2"
                                                        title={translate("progress_overall_card_title_session")}
                                                        cardData={indivPart.total[0] || {}}
                                                      />
                                                      <CompletionCard
                                                        type="8"
                                                        title={translate("progress_overall_card_title_badge")}
                                                        cardData={indivPart.total[0] || {}}
                                                        partTitle={indivPart.courseparttitle}
                                                      />
                                                       <CompletionCard
                                                        type="3"
                                                        title={translate("progress_overall_card_title_certificate")}
                                                        cardData={indivPart.total[0] || {}}
                                                        partTitle={indivPart.courseparttitle}
                                                      />
                                                    </div>
                                                  )}
                                                  {indivPart.courses &&
                                                    indivPart.courses.map((course: any, UnitIndex: number) => {
                                                      return (
                                                        <Accordion
                                                          className="accordion-main accordion-l1 indiv-unit-progress-accordion"
                                                          expanded={l1Expanded === `${hashText(course["skilltitle"])}_course_${UnitIndex}`}
                                                          onChange={handleAccordionChange(
                                                            `${hashText(course["skilltitle"])}_course_${UnitIndex}`,
                                                            1
                                                          )}
                                                        >
                                                          <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls={`panel1a-level-course-content_${hashText(course["skilltitle"])}_${UnitIndex}`}                                                            
                                                            id={`panel1a-level-course-header_${hashText(course["skilltitle"])}_${UnitIndex}`}
                                                          >
                                                            <div className="reach-skill-title">{course["skilltitle"]}</div>
                                                            <div className="unit-overall-container">
                                                              <UnitProgress
                                                                type="0"
                                                                title={translate("progress_overall_card_title_prework")}
                                                                cardData={
                                                                  allUnitsIndivList &&
                                                                  getIndivUnitScoreObj(course["skilltitle"], allUnitsIndivList)
                                                                  // allUnitCompletedList[index].units[UnitIndex]
                                                                }
                                                              />
                                                              <UnitProgress
                                                                type="1"
                                                                title={translate("progress_overall_card_title_session")}
                                                                cardData={
                                                                  allUnitsIndivList &&
                                                                  getIndivUnitScoreObj(course["skilltitle"], allUnitsIndivList)
                                                                  // allUnitCompletedList[index].units[UnitIndex]
                                                                }
                                                              />
                                                              <UnitProgress
                                                                type="2"
                                                                skillTitle={course["skilltitle"]}
                                                                title={translate("progress_overall_card_title_session")}
                                                                cardData={
                                                                  allUnitsIndivList &&
                                                                  getIndivUnitScoreObj(course["skilltitle"], allUnitsIndivList)
                                                                  // allUnitCompletedList[index].units[UnitIndex]
                                                                }
                                                              />
                                                            </div>
                                                          </AccordionSummary>
                                                          <AccordionDetails className="accordion-details">
                                                            {course.skillcourses && course.skillcourses.length > 0 ? (
                                                              course.skillcourses &&
                                                              course.skillcourses.map((subSkill: any) => {
                                                                if (subSkill.skilltypeid === 2) {
                                                                  return (
                                                                    <SubSkillCard
                                                                      subSkillData={subSkill}
                                                                      showHomeWork={false}
                                                                    ></SubSkillCard>
                                                                  );
                                                                }
                                                              })
                                                            ) : (
                                                                <div className="emptySubSkill">
                                                                  {translate("progress_tab_nodata")}
                                                                </div>
                                                              )}
                                                          </AccordionDetails>
                                                        </Accordion>
                                                      );
                                                    })}
                                                </div>
                                              )
                                            })
                                          }
                                        </TabPanel>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                            <div className="no-data-tab">{translate("progress_tab_nodata")}</div>
                          )}
                      </TabPanel>
                    );
                  } 
                  else if ((product.productId === "21"|| product.productId === "22"||product.productId === "23"||product.productId === "24") && structuredSoloData) {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        {structuredSoloData && structuredSoloData.length > 0 ? (
                          <div className="tab-main-body m0 p0 inside-tab">
                            <div className="reach-skills-body-container">
                              <div className="levels-progress-skills-card-ul">
                                <div>
                                  <AppBar position="static" color="default">
                                    <Tabs
                                      value={soloTab}
                                      onChange={handlesSoloChange}
                                      className={"tabs-trigger-container h2-tab"}
                                      indicatorColor="primary"
                                      textColor="primary"
                                      variant="scrollable"
                                      scrollButtons="auto"
                                      aria-label="sprint levels level tabs"
                                    >
                                      {structuredSoloData &&
                                        structuredSoloData.map((skill: any, index: number) => {
                                          return (
                                            <Tab
                                              label={skill["level"]}
                                              key={index * Math.random()}
                                              {...a11yProps_dynamic(index, "21")}
                                            />
                                          );
                                        })}
                                    </Tabs>
                                  </AppBar>
                                  {structuredSoloData &&
                                    structuredSoloData.map((skill: any, index: number) => {
                                      return (
                                        <TabPanel value={soloTab} index={index} key={index * Math.random()} prodId={"21"}>
                                          {
                                            skill.parts.parts && skill.parts.parts.length > 0 && skill.parts.parts.map((indivPart: any)=>{
                                              return (
                                                <div className="parts-block">
                                                  {indivPart && (
                                                    <div className="completion-card-cover spread">
                                                      <div className="part-title">{getPartTitle(indivPart.courseparttitle)}</div>
                                                      <CompletionCard
                                                        type="0"
                                                        title={translate("progress_activity_tooltip_activitiesCompleted")}
                                                        cardData={indivPart.total[0]|| {}}
                                                      />
                                                      <CompletionCard
                                                        type="8"
                                                        title={translate("progress_overall_card_title_badge")}
                                                        cardData={indivPart.total[0] || {}}
                                                        partTitle={indivPart.courseparttitle}
                                                      />
                                                       <CompletionCard
                                                        type="3"
                                                        title={translate("progress_overall_card_title_certificate")}
                                                        cardData={indivPart.total[0] || {}}
                                                        partTitle={indivPart.courseparttitle}
                                                      />
                                                    </div>
                                                  )}
                                                  {indivPart.courses &&
                                                    indivPart.courses.map((course: any, UnitIndex: number) => {
                                                      return (
                                                        <Accordion
                                                          className="accordion-main accordion-l1 indiv-unit-progress-accordion"
                                                          expanded={l1Expanded === `${hashText(course["skilltitle"])}_course_${UnitIndex}`}
                                                          onChange={handleAccordionChange(
                                                            `${hashText(course["skilltitle"])}_course_${UnitIndex}`,
                                                            1
                                                          )}
                                                        >
                                                          <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls={`panel1a-level-course-content_${hashText(course["skilltitle"])}_${UnitIndex}`}                                                            
                                                            id={`panel1a-level-course-header_${hashText(course["skilltitle"])}_${UnitIndex}`}
                                                          >
                                                            <div className="reach-skill-title">{course["skilltitle"]}</div>
                                                            <div className="unit-overall-container">
                                                              <UnitProgress
                                                                type="0"
                                                                title={translate("progress_activity_tooltip_activitiesCompleted")}
                                                                cardData={
                                                                  allUnitsIndivListSolo &&
                                                                  getIndivUnitScoreObj(course["skilltitle"], allUnitsIndivListSolo)
                                                                  // allUnitCompletedList[index].units[UnitIndex]
                                                                }
                                                              />
                                                              <UnitProgress
                                                                type="2"
                                                                skillTitle={course["skilltitle"]}
                                                                title={translate("progress_overall_card_title_session")}
                                                                cardData={
                                                                  allUnitsIndivListSolo &&
                                                                  getIndivUnitScoreObj(course["skilltitle"], allUnitsIndivListSolo)
                                                                  // allUnitCompletedList[index].units[UnitIndex]
                                                                }
                                                              />
                                                            </div>
                                                          </AccordionSummary>
                                                          <AccordionDetails className="accordion-details">
                                                            {course.skillcourses && course.skillcourses.length > 0 ? (
                                                              course.skillcourses &&
                                                              course.skillcourses.map((subSkill: any) => {
                                                                if (subSkill.skilltypeid === 2) {
                                                                  return (
                                                                    <SubSkillCard
                                                                      subSkillData={subSkill}
                                                                      showHomeWork={false}
                                                                      isSolo={true}
                                                                    ></SubSkillCard>
                                                                  );
                                                                }
                                                              })
                                                            ) : (
                                                                <div className="emptySubSkill">
                                                                  {translate("progress_tab_nodata")}
                                                                </div>
                                                              )}
                                                          </AccordionDetails>
                                                        </Accordion>
                                                      );
                                                    })}
                                                </div>
                                              )
                                            })
                                          }
                                        </TabPanel>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="no-data-tab">
                            {translate("progress_tab_nodata")}
                          </div>
                          )}
                      </TabPanel>
                    );
                  }else if (product.productId === "$0") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        <div className="test-results-all-cards-cover white">
                          <ChartsComponent pageInited={pageInited} />
                        </div>
                      </TabPanel>
                    );
                  }
                  else if (product.productId === "$1") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        <div className="test-results-all-cards-cover">
                          {testResultsList && testResultsList.length > 0 ? (
                            testResultsList.map((result) => {
                              return <TestResultCard portalLoginURL={portalLoginURL} result={result}></TestResultCard>;
                            })
                          ) : (
                              <div className="no-data-tab">{translate("progress_tab_nodata")}</div>
                            )}
                        </div>
                      </TabPanel>
                    );
                  }
                  else {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        <div className="no-data-tab">{translate("progress_tab_nodata")}</div>
                      </TabPanel>
                    );
                  }
                })}
            </div>
          </div>
        </div>
      ) : (
          <ErrorPage status={404} />
        )}
    </React.Fragment>
  );
};

ProgressPage.propTypes = {
  productsList: PropTypes.array,
};
function remapJSON(remappedJSON: any, soloDetails: any, allInfo: any, userskillscourseslist: any) {
  let courseLevel = soloDetails.courseName.split(" ");
  remappedJSON = {};
  remappedJSON.skilltitle = soloDetails.moduleName;
  remappedJSON.userid = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
  remappedJSON.username = "";
  remappedJSON.skilllevel = courseLevel[courseLevel.length - 1];
  remappedJSON.skillcourses = [];
  let course : any ={};
  soloDetails.units.map((units: any, index : number) => {
    if(!!units.unitName)
    {
    course = {};
    course.subskillid = units.unitId;
    course.subskilltitle = units.unitName;
    course.courseparttitle = units.coursePartTitle;
    course.skilltypeid = 2;
    course.totalprework = units.totalActivity;
    course.preworkcompleted = units.activityCompleted;
    course.totalhomework = 0;
    course.homeworkcompleted = 0;
    course.totalsession = 0;
    course.sessioncompleted = 0;
    course.sessionstatus = "N/A";
    remappedJSON.skillcourses.push(course);
    }
  });
  userskillscourseslist.data.userskillscourseslist.push(remappedJSON);
  return userskillscourseslist;
}

export default ProgressPage;

